module.exports = __webpack_public_path__ + "img/infohub-blue-logo-slim.6bbe2c69.svg";